module.exports = __webpack_public_path__ + "assets/media/lunch.e64f4426.mp3";